import ForgetPasswordComponent from "../Component/Password/ForgerPassword";

const ForgetPassword = () => {
    return(
        <ForgetPasswordComponent />
    )
}


export default ForgetPassword